import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

/**
 * Toggle a charter table / trip calendar panel between split and enlarged view.
 * @param {'table'|'calendar'|null} expandedPanel
 * @param {'table'|'calendar'} panel
 */
const PanelExpandButton = ({ expandedPanel, panel, onChange, size = 'small' }) => {
  const isExpanded = expandedPanel === panel;
  const label = isExpanded ? 'Restore split view' : `Enlarge ${panel === 'table' ? 'table' : 'calendar'}`;

  return (
    <Tooltip title={label}>
      <IconButton
        size={size}
        aria-label={label}
        onClick={() => onChange(isExpanded ? null : panel)}
        sx={{ flexShrink: 0 }}
      >
        {isExpanded ? (
          <CloseFullscreenIcon fontSize="inherit" />
        ) : (
          <OpenInFullIcon fontSize="inherit" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default PanelExpandButton;

/** Shared Paper grid sx for charter + calendar layout with optional enlarge. */
export const getCharterCalendarPaperSx = (expandedPanel) => ({
  border: '4px solid',
  borderColor: 'grey.700',
  borderRadius: 2,
  p: 1.5,
  display: 'grid',
  // Only table enlarge collapses to a single column; calendar opens a 70vw horizontal dialog.
  gridTemplateColumns:
    expandedPanel === 'table'
      ? '1fr'
      : { xs: '1fr', md: 'minmax(0, 65fr) minmax(0, 35fr)' },
  gap: 1.5,
  alignItems: 'stretch',
  bgcolor: 'grey.100',
  minHeight: expandedPanel === 'table' ? { xs: '70vh', md: '75vh' } : undefined
});

/** Dialog Paper sx: horizontal calendar covering ~70% of the viewport width. */
export const calendarEnlargeDialogPaperSx = {
  width: { xs: '96vw', md: '70vw' },
  maxWidth: { xs: '96vw', md: '70vw' },
  height: { xs: '80vh', md: '78vh' },
  maxHeight: '85vh',
  m: 0,
  borderRadius: 2,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
};
